module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAA7AAAAOwBeShxvQAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAABJSURBVFiFY2AYBaNgFAwwYEQX0Fv/4T8tLbwUKIBiJxMtLRsFo2AUEAMwyoGlD//TtByIlmccLQdGwSgYXGC0PTAKRsEoGHAAADieDAo7CWR+AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic/menu.png
// module id = bMPK
// module chunks = 8